import { TitleCasePipe } from "@angular/common";
import { Component, EventEmitter, Output } from "@angular/core";
import { ButtonComponent } from "@kinomap-dev/ng-ui-lib";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-connection-modal",
    template: `
    <h2 class="modal-header">{{ 'common.connection_more' | translate }}</h2>
    <div class="modal-content" [innerHtml]="'connection.not_log_msg' | translate"></div>
    <div class="modal-footer">
        <kin-btn [extended]="true" [shadow]="true" (click)="login.emit()" color="primary"> {{ 'common.signin' | translate }} </kin-btn>
        <kin-btn [extended]="true" [shadow]="true" (click)="signup.emit()" color="dark"> {{ 'common.create_my_account' | translate }} </kin-btn>
    </div>
    `,
    styleUrls: ["./connection-modal.component.scss"],
    standalone: true,
    imports: [ButtonComponent, TranslateModule]
})
export class ConnectionModalComponent {
    @Output() login: EventEmitter<void> = new EventEmitter<void>();
    @Output() signup: EventEmitter<void> = new EventEmitter<void>();
}